import React, { Suspense, useCallback, useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import { uploadDoc } from "../../../Services/Global-Services/GlobalServices";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { uploadImageAlbum } from "./galleryService";
import { TostMsg } from "../../../App";
import { LoaderContext } from "../../../Services/Loader_Provider_Service/LoadingContext";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

function AddMedia() {
  const [file, setFile] = useState(null);
  const history = useHistory();
  const [uploadedImages, setUploadedImages] = useState([]);
  const toster = useContext(TostMsg);
  const { AlbumId } = useParams();
  const [loading, setLoading] = useState(false);
  const [showImg, setShowImg] = useState(false);

  const fileInputRef = useRef(null);
  function openFileInput() {

    fileInputRef.current.click();
  }

  const handleFileChange = useCallback(async (event) => {
    const selectedFile = await event.target.files;
    setFile(selectedFile);
  }, []);

  useEffect(() => {
    if (file?.length > 0) {
      uploadMediaFile();
    }
  }, [file]);

  async function uploadMediaFile() {
    setLoading(true);
    if (file && file.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      try {
        const response = await uploadDoc(formData);
        const data = await response;
        setLoading(false);
        const ImageURL = data?.Data;
        if (ImageURL && ImageURL.length > 0) {
          const processedMedia = [];
          for (let i = 0; i < ImageURL.length; i++) {
            const media = ImageURL[i];
            const currentFile = file[i];
            if (media.slice(-3) === "mp4") {
              const duration = await getVideoDuration(media);
              processedMedia.push({
                MediaPath: media,
                MediaSize: currentFile.size,
                MediaDuration: duration,
                MediaType: currentFile.type,
              });
            } else {
              processedMedia.push({
                MediaPath: media,
                MediaSize: currentFile.size,
                MediaDuration: 0,
                MediaType: currentFile.type,
              });
            }
          }
          setShowImg(true);
          setUploadedImages((prev) => [...prev, ...processedMedia]);
        }
      } catch (error) {
        setLoading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
      toster.current.warn("No file selected.");
    }
  }

  function getVideoDuration(mediaPath) {
    return new Promise((resolve) => {
      const videoElement = document.createElement("video");
      videoElement.src = mediaPath;
      videoElement.addEventListener("loadedmetadata", () => {
        resolve(videoElement.duration);
      });
    });
  }

  async function uploadImageAlbumData() {
    setLoading(true);
    const body = {
      AlbumId: Number(AlbumId),
      AlbumMedias: uploadedImages
    };
    await uploadImageAlbum(body);
    try {
      history.push("/Gallery");
      toster.current.success("Album updated successfully");
      setLoading(false);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
      setLoading(false);
    }
  }

  const FeedCarouselTemplate = useCallback((media) => {
    const isVideo = media?.MediaPath?.endsWith(".mp4");
    const mediaSrc = media?.MediaPath
    return isVideo ? (
      <video src={mediaSrc} poster={mediaSrc} controls />
    ) : (
      <img src={mediaSrc} alt="Description of the image" />
    );
  }, []);

  return (
    <div className=" gallery-popupdiv">
      <div className="container-fluid">
        <div className="form-head d-flex flex-wrap align-items-center">
          <div className="me-auto">
            <h2 className="font-w600 mb-0">Add Images</h2>
            <p className="text-light">Lorem ipsum dolor sit amet </p>
          </div>
          <Link to="/Gallery" className="add-btncss gal-a">
            <i aria-hidden="true" className="fa fa-angle-left me-2"></i>Back
          </Link>
        </div>
        <div className="popup">
          {/*<!-- top bar -->  */}
          <div className="top-bar">
            <p className="image-name" style={{ visibility: "hidden" }}>
              img1.png
            </p>
            <span className="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-x close-btn ml-auto"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </span>
          </div>
          {/* <!-- arrows --> */}
          <button className="arrow-btn left-arrow">
            <img
              src="https://github.com/kunaal438/image-popup/blob/master/img/arrow.png?raw=true"
              alt=""
            />
          </button>
          <button className="arrow-btn right-arrow">
            <img
              src="https://github.com/kunaal438/image-popup/blob/master/img/arrow.png?raw=true"
              alt=""
            />
          </button>
          {/* <!-- image --> */}
          <div className="row">
            <div className="col-lg-8 p-0">
              <img
                src="images/gallery/1.jpg"
                className="large-image w-100 h-100 mt-0"
                alt=""
              />
            </div>
            <div className="col-lg-4 p-0">
              <div className="bg-white w-100 d-block commhight">
                <div className="user-info">
                  <a >Single Album Category</a>
                  <span className="time">July 26 2018, 01:03pm</span>
                  <p className="gallery-para">
                    Reference site about Lorem Ipsum, giving informaon its
                    origins, as well as a random Lipsum generato
                  </p>
                  <div
                    className="inner-content d-flex"
                    style={{ marginLeft: "auto" }}
                  >
                    <p className="mr-4 mb-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-heart-fill mr-3 color-red"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                        ></path>
                      </svg>
                      12
                    </p>
                    <p className="mb-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chat-dots-fill mr-3 color-grey"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path>
                      </svg>
                      5
                    </p>
                  </div>

                  <div className="mt-3 comment-div">
                    <strong>{T("Comments")}</strong>
                    <div className="card is-post">
                      <div className="content-wrap">
                        <div
                          className="card-heading"
                          style={{ alignItems: "inherit" }}
                        >
                          <div className="user-block">
                            <div className="image w-auto">
                              <img
                                src="images/main-body/user1.jpg"
                                data-demo-src="assets/img/avatars/elise.jpg"
                                data-user-popover="6"
                                alt=""
                              />
                            </div>
                            <div className="user-info">
                              <a >Elise Walker</a>
                              <span className="time">
                                July 19 2018, 19:42pm
                              </span>
                              <p className="m-0">
                                Reference site about Lorem Ipsum, giving
                                information on its origins, as well as a random
                                Lipsum generator.
                              </p>
                              <ul className="d-flex">
                                <li className="pr-3">Like</li>
                                <li>Reply</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div
                          className="card-heading"
                          style={{ alignItems: "inherit" }}
                        >
                          <div className="user-block">
                            <div className="image w-auto">
                              <img
                                src="images/main-body/user1.jpg"
                                data-demo-src="assets/img/avatars/elise.jpg"
                                data-user-popover="6"
                                alt=""
                              />
                            </div>
                            <div className="user-info">
                              <a >Elise Walker</a>
                              <span className="time">
                                July 19 2018, 19:42pm
                              </span>
                              <p className="m-0">
                                Reference site about Lorem Ipsum, giving
                                information on its origins, as well as a random
                                Lipsum generator.
                              </p>
                              <ul className="d-flex">
                                <li className="pr-3">Like</li>
                                <li>Reply</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div
                          className="card-heading"
                          style={{ alignItems: "inherit" }}
                        >
                          <div className="user-block">
                            <div className="image w-auto">
                              <img
                                src="images/main-body/user1.jpg"
                                data-demo-src="assets/img/avatars/elise.jpg"
                                data-user-popover="6"
                                alt=""
                              />
                            </div>
                            <div className="user-info">
                              <a >Elise Walker</a>
                              <span className="time">
                                July 19 2018, 19:42pm
                              </span>
                              <p className="m-0">
                                Reference site about Lorem Ipsum, giving
                                information on its origins, as well as a random
                                Lipsum generator.
                              </p>
                              <ul className="d-flex">
                                <li className="pr-3">Like</li>
                                <li>Reply</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h1 className="index">01</h1>
          </div>
        </div>
        <a
          className="add-gallery"
          style={{ position: "relative" }}
        >
          <div>
            <input
              type="file"
              name="file"
              multiple
              style={{
                position: "absolute",
                top: "43%",
                right: "33%",
                visibility: "hidden",
              }}
              ref={fileInputRef}
              onChange={handleFileChange}
            />
            <img src="/images/org-img/gallery/plus.png"
              onClick={openFileInput}
            />
            <span>Add pictures in album</span>
            {showImg && <div className="upload__img-wrap galleryupload__img-wrap">
              {showImg && uploadedImages?.map((img) =>
                <div className="upload__img-box">
                  {FeedCarouselTemplate(img)}
                </div>
              )}
              <button onClick={() => uploadImageAlbumData()} className="add-btncss gal-a mb-2">
                <i aria-hidden="true" className="fa fa-upload me-2"></i>Upload image
              </button>
            </div>}
          </div>
        </a>

      </div>
      {loading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>

  );
}

export default AddMedia;
